import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Divider, Grid, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useShopCart } from 'src/Libs/shop/hooks'
import { PaymentMethodResponseModel } from 'src/Libs/shop/models'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()(theme => ({
  container: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    minHeight: '300px',
  },
  normalText: {
    color: theme.palette.text.primary,
    borderColor: theme.palette.grey.grey03,
  },
  description: {
    maxWidth: '100%',
    marginTop: theme.spacing(2),
    fontWeight: '400',
  },
}))

const ConfirmCheckoutPaymentMethod: React.FC = () => {
  const { t } = useCustomTranslation()
  const { classes, cx } = useStyles()
  const [paymentMethod, setPaymentMethod] = useState<PaymentMethodResponseModel | null>(null)
  const { loadPaymentMethod } = useShopCart()

  useEffect(() => {
    loadPaymentMethod()
      .then(result => {
        setPaymentMethod(result)
      })
      .catch(e => {
        console.error(e)
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Grid item xs={12} md={6} className={classes.container}>
      <Typography variant="h2" sx={{ fontWeight: 400 }} className={classes.normalText}>
        {t('shop.confirm-checkout.payment-method')}
      </Typography>
      <Divider className={classes.normalText} variant="fullWidth" />
      <Typography variant="h6" className={cx(classes.normalText, classes.description)}>
        {t('shop.confirm-checkout.invoice')}
      </Typography>
      <Typography className={classes.normalText} sx={{ maxWidth: '100%', minHeight: '160px', lineHeight: '24px' }}>
        {paymentMethod?.paymentMethod.translated.description}
      </Typography>
    </Grid>
  )
}

export default ConfirmCheckoutPaymentMethod
